// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wAb6I","inline":"styles_inline__1imB_","large":"styles_large__1l7kk","pearl":"styles_pearl__2YK-i","ghost":"styles_ghost__38sqc"};